export type LeadLegalField =
  | 'cpf'
  | 'rg'
  | 'profession'
  | 'maritalStatus'
  | 'nationality'
  | 'address';

function normalizeKey(key: string): string {
  return key
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function includesAny(normalizedKey: string, keywords: string[]): boolean {
  return keywords.some((keyword) => normalizedKey.includes(keyword));
}

export function leadLegalVariableField(key: string): LeadLegalField | null {
  const normalizedKey = normalizeKey(key);

  if (normalizedKey.includes('cpf')) return 'cpf';
  if (normalizedKey.includes('rg')) return 'rg';
  if (includesAny(normalizedKey, ['profiss', 'profession'])) {
    return 'profession';
  }
  if (includesAny(normalizedKey, ['estadocivil', 'estado_civil', 'marital'])) {
    return 'maritalStatus';
  }
  if (includesAny(normalizedKey, ['nacionalidade', 'nationality'])) {
    return 'nationality';
  }
  if (includesAny(normalizedKey, ['endereco', 'address'])) return 'address';

  return null;
}
